import React from "react";
import "./style.css";
const CardChip = ({ name, cardColorClass }) => {
  return (
    <div className={`card_chip ${cardColorClass}`}>
      <p>{name}</p>
    </div>
  );
};

export default CardChip;
